import Crud from '../crud'
import ApiService from '../../utils/api.service'
import { API_VERSION } from '../../utils/config'
import {
  CREATE_BATCH,
  EXTRACT_ITEM,
  PATCH_ITEM,
  SET_PROGRAMME_MAPPING,
  CREATE_PRODUCT,
  FETCH_ISSUER_PROGRAMS,
} from '../actions/productImportBatch'

const endpoint = 'product-import-batches'
const crud = new Crud(endpoint)

const actions = {
  ...crud.actions,

  // Upload the zip -> the backend stores it + each PDF and returns the batch with items.
  [CREATE_BATCH]: async (_, zipFile) => {
    const formData = new FormData()
    formData.append('archive', zipFile)
    const { data } = await ApiService.post(`api/${API_VERSION}/${endpoint}/`, formData)
    return data
  },

  // Extract one already-stored PDF by document_id (no re-upload) via the existing reader.
  [EXTRACT_ITEM]: async (_, { documentId }) => {
    const formData = new FormData()
    formData.append('document_id', documentId)
    const { data } = await ApiService.post(`api/${API_VERSION}/products/llm-termsheet-reader`, formData)
    return data
  },

  [PATCH_ITEM]: async (_, { batchId, itemId, patch }) => {
    const { data } = await ApiService.patch(`api/${API_VERSION}/${endpoint}/${batchId}/items/${itemId}`, patch)
    return data
  },

  [SET_PROGRAMME_MAPPING]: async (_, { batchId, mapping }) => {
    const { data } = await ApiService.patch(`api/${API_VERSION}/${endpoint}/${batchId}`, { programme_mapping: mapping })
    return data
  },

  // Create one unallocated product (mirrors product/ADD -> POST /products/).
  [CREATE_PRODUCT]: async (_, product) => {
    const { data } = await ApiService.post(`api/${API_VERSION}/products/`, product)
    return data
  },

  // Load an issuer with its embedded programmes (same `full` payload ProductForm uses).
  [FETCH_ISSUER_PROGRAMS]: async (_, issuerId) => {
    const { data } = await ApiService.get(`api/${API_VERSION}/issuers/${issuerId}?full=true`)
    return data.programs || []
  },
}

export default {
  state: { ...crud.state },
  getters: { ...crud.getters },
  actions,
  mutations: { ...crud.mutations },
}
